import React, { useRef, useState } from "react";
import { useFormik } from "formik";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { useNavigate, Link } from "react-router-dom";
import { Table } from "antd";
import DatePicker from "react-datepicker";
// import Accordion from 'react-bootstrap/Accordion';
import Select from "react-select";
import * as Yup from "yup";
// import { adminMainUrl } from '../../Config';
import Offcanvas from "react-bootstrap/Offcanvas";
// import { adminMainUrl } from '../../../../Config';
const AddMaster = ({ show, handleClose, onSuccess }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [isChecked1, setIsChecked1] = useState(false);
  const [isChecked2, setIsChecked2] = useState(false);
  const closeButtonRef = useRef(null);
  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    code: Yup.string().required("Code is required"),
    short_name: Yup.string().required("Short Name is required"),
    applicabl_for: Yup.string().required("Applicable for is required"),
    charge_category: Yup.string().required("Charge Category is required"),
    IATA_code: Yup.string().required("IATA Code is required"),
    vendor: Yup.string().required("Vendor is required"),
    Remarks: Yup.string().required("Remarks is required"),
    valid_till: Yup.string().required("Valid Till is required"),
    valid_from: Yup.string().required("Valid From is required"),
    contract_date: Yup.string().required("Contract Date is required"),
    contract_no: Yup.string().required("Contract Date is required"),
    ref_date : Yup.string().required("Ref. Date  is required"),
    ref_no : Yup.string().required("Ref. No. is required"),
    notes : Yup.string().required("Notes is required"),
    date : Yup.string().required("Date is required"),
    cal_Method : Yup.string().required("Cal. Method is required"),
    rate : Yup.string().required("Rate is required"),
    basis : Yup.string().required("Basis is required"),
    charge_head : Yup.string().required("Charge Head is required"),
    // name: Yup.string().required('Code is required'),
  });

  const [startDate, setStartDate] = useState(new Date());

  // Initialize Formik
  const formik = useFormik({
    initialValues: {
      name: "", // Initial value for the RequiredService type
      code: "",
      short_name: "",
      applicabl_for: "",
      charge_category: "",
      IATA_code: "",
      name: "",
      vendor: "",
      Remarks: "",
      valid_till: "",
      valid_from: "",
      contract_date: "",
      contract_no: "",
      ref_date: "",
      ref_no: "",
      notes: "",
      date: "",
      cal_Method: "",
      rate: "",
      basis: "",
      charge_head: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      handleClose();
      formik.resetForm();
      setIsSubmitting(true);
      // try {
      //     const response = await fetch(`${adminMainUrl}/api/department/create`, {
      //         method: 'POST',
      //         headers: {
      //             'Content-Type': 'application/json',
      //             'auth-token': Cookies.get('token'), // Assuming token is stored in cookies
      //         },
      //         body: JSON.stringify(values),
      //     });

      //     const data = await response.json();

      //     if (response.ok) {
      //         // closeButtonRef.current.click();
      //         if (onSuccess) onSuccess();
      //         toast.success(data?.msg);
      //         handleClose()
      //         formik.resetForm();
      //     } else {
      //         toast.error(data?.msg);
      //         // Handle errors from the server
      //         console.error('Error creating RequiredService Type:', data.message);
      //     }
      // } catch (error) {
      //     console.error('Network error:', error);
      // }
      // finally {
      //     setIsSubmitting(false); // Stop the spinner
      // }
    },
  });
  const [editshow, setEditShow] = useState(false);
  const handleEditClose = () => setEditShow(false);
  const handleEditShow = () => setEditShow(true);
  const columns1 = [
    { title: "S. No.", dataIndex: "SNo", key: "SNo" },
    { title: "Charge Head", dataIndex: "Head", key: "Head" },
    { title: "Basis", dataIndex: "Basis", key: "Basis" },
    { title: "Rate", dataIndex: "Rate", key: "Rate" },
    { title: "Cal. Method", dataIndex: "Method", key: "Method" },
    { title: "Min. Amount", dataIndex: "Rate", key: "Rate" },
    { title: "Action", dataIndex: "action", key: "action" },
  ];

  const dataSource1 = [
    {
      key: "1", // Add a unique key for each row
      SNo: "1", // Changed to camelCase
      Name: "John",
      Type: "AE",
      Group: "ddsvd",
      action: (
        <div className="dropdown table-action">
          <Link to="#" className="action-icon" data-bs-toggle="dropdown">
            <i className="fa fa-ellipsis-v"></i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <div className="dropdown-item cursor-pointer" to="#">
              <i className="fas fa-trash text-blue me-2"></i> Delete
            </div>
          </div>
        </div>
      ),
    },
  ];
  const columns2 = [
    { title: "S. No.", dataIndex: "SNo", key: "SNo" },
    { title: "Date", dataIndex: "Date", key: "Date" },
    { title: "Notes", dataIndex: "Notes", key: "Notes" },
    { title: "Action", dataIndex: "action", key: "action" },
  ];

  const dataSource2 = [
    {
      key: "1", // Add a unique key for each row
      SNo: "1", // Changed to camelCase
      Name: "John",
      Type: "AE",
      Group: "ddsvd",
      action: (
        <div className="dropdown table-action">
          <Link to="#" className="action-icon" data-bs-toggle="dropdown">
            <i className="fa fa-ellipsis-v"></i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <div className="dropdown-item cursor-pointer" to="#">
              <i className="fas fa-trash text-blue me-2"></i> Delete
            </div>
          </div>
        </div>
      ),
    },
  ];

  const ApplicableOption = [
    { value: "aizobel", label: "Aizobel / INAZ" },
    { value: "bagdogra", label: "Bagdogra / INBD" },
    { value: "akola", label: "Akola / INAL" },
    { value: "amritsar", label: "Amritsar / INAR" },
  ];

  return (
    <Offcanvas className="" show={show} onHide={handleClose} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Add Vendor Contract</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <form onSubmit={formik.handleSubmit}>
          <div className="row mb-3">
            <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor="name" className="form-label">
                  Ref. No. <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="ref_no"
                  name="ref_no"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.ref_no}
                />
                {formik.touched.name && formik.errors.ref_no ? (
                  <div className="error">{formik.errors.ref_no}</div>
                ) : null}
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor="nacdsme" className="form-label">
                  Ref. Date <span style={{ color: "red" }}>*</span>
                </label>
                <div className="custom-datepicker">
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    id="ref_date"
                  name="ref_date"
                  value={formik.values.ref_date}
                  />
                  <span style={{ top: "13px" }}>
                    <img src="/img/date.png" alt="" />
                  </span>
                </div>
                {formik.touched.name && formik.errors.ref_date ? (
                  <div className="error">{formik.errors.ref_date}</div>
                ) : null}
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor="name" className="form-label">
                  Vendor <span style={{ color: "red" }}>*</span>
                </label>
                <input 
                  type="text"
                  className="form-control form-control-sm"
                  id="vendor"
                  name="vendor"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.vendor}
                />
                {formik.touched.vendor && formik.errors.vendor ? (
                  <div className="error">{formik.errors.vendor}</div>
                ) : null}
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor="name" className="form-label">
                  Contract No. <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="contract_no"
                  name="contract_no"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.contract_no}
                />
                {formik.touched.name && formik.errors.contract_no ? (
                  <div className="error">{formik.errors.contract_no}</div>
                ) : null}
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor="name" className="form-label">
                  Contract Date <span style={{ color: "red" }}>*</span>
                </label>
                <div className="custom-datepicker">
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    id="contract_date"
                  name="contract_date"
                  value={formik.values.contract_date}
                  />
                  <span style={{ top: "13px" }}>
                    <img src="/img/date.png" alt="" />
                  </span>
                </div>
                {formik.touched.name && formik.errors.contract_date ? (
                  <div className="error">{formik.errors.contract_date}</div>
                ) : null}
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor="name" className="form-label">
                  Valid From <span style={{ color: "red" }}>*</span>
                </label>
                <div className="custom-datepicker">
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    id="valid_from"
                  name="valid_from"
                  value={formik.values.valid_from}
                  />
                  <span style={{ top: "13px" }}>
                    <img src="/img/date.png" alt="" />
                  </span>
                </div>
                {formik.touched.name && formik.errors.valid_from ? (
                  <div className="error">{formik.errors.valid_from}</div>
                ) : null}
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor="name" className="form-label">
                  Valid Till <span style={{ color: "red" }}>*</span>
                </label>
                <div className="custom-datepicker">
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    id="valid_till"
                  name="valid_till"
                  value={formik.values.valid_till}
                  />
                  <span style={{ top: "13px" }}>
                    <img src="/img/date.png" alt="" />
                  </span>
                </div>
                {formik.touched.name && formik.errors.valid_till ? (
                  <div className="error">{formik.errors.valid_till}</div>
                ) : null}
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor="name" className="form-label">
                  Remarks <span style={{ color: "red" }}>*</span>
                </label>
                <textarea
                  type="text"
                  className="form-control"
                  id="Remarks"
                  name="Remarks"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.Remarks}
                ></textarea>
                {formik.touched.name && formik.errors.Remarks ? (
                  <div className="error">{formik.errors.Remarks}</div>
                ) : null}
              </div>
            </div>
          </div>
          <div className="col-12">
            <div className="mb-3">
              <div className="card">
                <div className="card-header">Charges</div>
                <div className="card-body">
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <div className="mb-2 ">
                        <label htmlFor="name" className="form-label ">
                          Charge Head <span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="w-100">
                          <Select
                            className="custom-selector"
                            options={ApplicableOption}
                            id="charge_head"
                            name="charge_head"
                  value={formik.values.charge_head}
                            onChange={(selectedOption) =>
                              formik.setFieldValue(
                                "applicableFor",
                                selectedOption.value
                              )
                            }
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.name && formik.errors.charge_head ? (
                            <div className="error">{formik.errors.charge_head}</div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-2 ">
                        <label htmlFor="name" className="form-label ">
                          Basis <span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="w-100">
                          <Select
                            className="custom-selector"
                            options={ApplicableOption}
                            id="basis"
                            name="basis"
                  value={formik.values.basis}
                            onChange={(selectedOption) =>
                              formik.setFieldValue(
                                "applicableFor",
                                selectedOption.value
                              )
                            }
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.name && formik.errors.basis ? (
                            <div className="error">{formik.errors.basis}</div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-2 ">
                        <label htmlFor="name" className="form-label ">
                          Rate <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                  type="text"
                  className="form-control form-control-sm"
                  id="rate"
                  name="rate"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.rate}
                />
                {formik.touched.name && formik.errors.rate ? (
                  <div className="error">{formik.errors.rate}</div>
                ) : null}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-2 ">
                        <label htmlFor="name" className="form-label ">
                          Cal. Method <span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="w-100">
                          <Select
                            className="custom-selector"
                            options={ApplicableOption}
                            id="cal_Method"
                            name="cal_Method"
                  value={formik.values.cal_Method}
                            onChange={(selectedOption) =>
                              formik.setFieldValue(
                                "applicableFor",
                                selectedOption.value
                              )
                            }
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.name && formik.errors.cal_Method ? (
                            <div className="error">{formik.errors.cal_Method}</div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 mt-3">
                      <button className="btn btn-primary text-xs" type="submit">
                        Add Charges
                      </button>
                    </div>
                  </div>
                  <div className="table-responsive custom-table">
                    <Table
                      className="table datanew dataTable no-footer"
                      pagination={false}
                      dataSource={dataSource1}
                      columns={columns1}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12">
            <div className="mb-3">
              <div className="card">
                <div className="card-header">Notes</div>
                <div className="card-body">
                  <div className="row mb-3">
                    <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor="name" className="form-label">
                  Date <span style={{ color: "red" }}>*</span>
                </label>
                <div className="custom-datepicker">
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                  id="date"
                  name="date"
                  value={formik.values.date}
                  />
                  <span style={{ top: "13px" }}>
                    <img src="/img/date.png" alt="" />
                  </span>
                </div>
                {formik.touched.name && formik.errors.date ? (
                  <div className="error">{formik.errors.date}</div>
                ) : null}
              </div>
            </div>
                    <div className="col-md-6">
                      <div className="mb-2 ">
                        <label htmlFor="name" className="form-label ">
                          Predefined Notes
                        </label>
                        <div className="w-100">
                          <Select
                            className="custom-selector"
                            options={ApplicableOption}
                            onChange={(selectedOption) =>
                              formik.setFieldValue(
                                "applicableFor",
                                selectedOption.value
                              )
                            }
                            onBlur={formik.handleBlur}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-2 ">
                        <label htmlFor="name" className="form-label ">
                          Notes <span style={{ color: "red" }}>*</span>
                        </label>
                        <textarea
                  type="text"
                  className="form-control"
                  id="notes"
                  name="notes"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.notes}
                ></textarea>
                {formik.touched.name && formik.errors.notes ? (
                  <div className="error">{formik.errors.notes}</div>
                ) : null}
                      </div>
                    </div>
                    <div className="col-md-6 mt-3">
                      <button className="btn btn-primary text-xs" type="submit">
                        Add Notes
                      </button>
                    </div>
                  </div>
                  <div className="table-responsive custom-table">
                    <Table
                      className="table datanew dataTable no-footer"
                      pagination={false}
                      dataSource={dataSource2}
                      columns={columns2}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end gap-2 mt-2">
            {/* <button className="btn btn-primary text-xs" type="submit" disabled={isSubmitting}>
                            {isSubmitting ? <i className="fa fa-spinner fa-spin" /> : "Submit"}
                        </button> */}
            <button
              className="btn btn-primary text-xs"
              type="submit"
              onClick={handleClose}
            >
              Submit
            </button>
            <button className="btn btn-primary text-xs" type="submit">
                            Save & Close
                        </button>
                        <button className="btn btn-primary text-xs" type="submit">
                            Save & New
                        </button>
                        <button className="btn btn-light text-xs" type="submit" onClick={handleClose}>
                            Close
                        </button>
          </div>
        </form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default AddMaster;
